import React, { useMemo, useEffect } from 'react';
import sound from './attention.mp3'; // https://dova-s.jp/se/play127.html
import { cancellable } from 'services/utility/cancellable';

export type AttentionSoundProps = {
    url?: string;
}

export function AttentionSound(props: AttentionSoundProps) {
    const { url = sound } = props;

    const audio = useMemo(() => {
        const audio = new Audio(url);
        audio.loop = true;
        audio.muted = false;
        return audio;
    }, [url]);

    useEffect(() => {
        return cancellable(async isCancel => {
            try {
                await audio.play();
                if (isCancel()) return;
            } catch (e) {
                console.error(e);
            }
        });
    }, [audio]);

    useEffect(() => {
        return () => audio.pause();
    }, [audio]);

    return <></>;
}
